import React from 'react'

export interface IProps {
    width?: number
    height?: number
}

const TwitterIcon = ({ width = 24, height = 24 }: IProps) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 24 24' fill='none'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M19 21H5C3.8955 21 3 20.1045 3 19V5C3 3.8955 3.8955 3 5 3H19C20.1045 3 21 3.8955 21 5V19C21 20.1045 20.1045 21 19 21Z'
                fill='#212121'
            />
            <path
                d='M17.1281 17H13.9096L6.91406 7H10.1326L17.1281 17ZM14.2931 16.152H15.5746L9.74906 7.848H8.46756L14.2931 16.152Z'
                fill='white'
            />
            <path d='M7.93263 17L11.5341 12.828L11.0631 12.2035L6.91113 17H7.93263Z' fill='white' />
            <path d='M12.2246 10.8605L12.6771 11.505L16.5676 7H15.5676L12.2246 10.8605Z' fill='white' />
        </svg>
    )
}

export default React.memo(TwitterIcon)
